import "core-js/modules/es.array.for-each";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetShopGiftCountList, DownloadShopGiftCount } from '@/api/bairun/saleDetail'; //  此处请自行替换地址

import { getShiftInfoList } from '@/api/bairun/bairunData.js'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import SearchTerm from '@/components/searchTerm';
import { saveAs } from 'file-saver';
import { mapGetters } from "vuex";

var _this;

export default {
  name: 'GoodsGiftCount',
  filters: {
    formatDate: function formatDate(time, format) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, format || 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatDatePayAt: function formatDatePayAt(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    }
  },
  components: {
    SearchTerm: SearchTerm
  },
  mixins: [infoList],
  computed: _objectSpread({}, mapGetters('stations', ['asyncStationMap'])),
  data: function data() {
    return {
      listApi: GetShopGiftCountList,
      type: '',
      dialogVisible: false,
      loading: false,
      downloading: false,
      searchInfo: {
        // 按配置顺序显示
        'sellerOrderType': 2,
        'sellerId': '',
        'shiftDate': '',
        'createdAtStart': '',
        'createdAtEnd': '',
        'giftGoodsName': '',
        'goodsNo': ''
      },
      multipleSelection: [],
      formData: {}
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.getDict('orderStatus');

              case 2:
                _context3.next = 4;
                return _this3.getDict('refundStatus');

              case 4:
                _this3.formData = _this3.initData();

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      var formdata = {};
      return formdata;
    },
    // 条件搜索前端看此方法
    onSearch: function onSearch() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.page = 1;
                _this4.pageSize = 10;
                _this4.loading = true;
                _context4.next = 5;
                return _this4.getTableData();

              case 5:
                _this4.loading = false;

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onDownload: function onDownload() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.downloading = true;
                _context5.next = 3;
                return DownloadShopGiftCount(_this5.searchInfo);

              case 3:
                res = _context5.sent;
                _this5.downloading = false;

                if (res.code == 0) {
                  saveAs(res.data.fileUrl);
                }

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    onSearchChange: function onSearchChange(formItem) {
      if (formItem.name === 'shiftDate') {
        this.onShiftDateChange(formItem.value);
      }
    },
    onShiftDateChange: function onShiftDateChange(time) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res, minStart, maxEnd;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (_this6.searchInfo.sellerId) {
                  _context6.next = 4;
                  break;
                }

                _this6.searchInfo.shiftDate = '';

                _this6.$message({
                  type: 'error',
                  message: '请选择油站'
                });

                return _context6.abrupt("return");

              case 4:
                _context6.next = 6;
                return getShiftInfoList({
                  page: 1,
                  pageSize: 10,
                  stationId: _this6.searchInfo.sellerId,
                  shiftDate: time
                });

              case 6:
                res = _context6.sent;

                if (res.code == 0) {
                  minStart = '';
                  maxEnd = '';
                  res.data.list && res.data.list.forEach(function (item) {
                    if (minStart === '' || new Date(item.startDate) < new Date(minStart)) {
                      minStart = formatTimeToStr(item.startDate, 'yyyy-MM-dd hh:mm:ss');
                    }

                    if (maxEnd === '' || new Date(item.endDate) > new Date(maxEnd)) {
                      maxEnd = formatTimeToStr(item.endDate, 'yyyy-MM-dd hh:mm:ss');
                    }
                  });
                  _this6.searchInfo.createdAtStart = minStart;
                  _this6.searchInfo.createdAtEnd = maxEnd;
                }

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    closeDialog: function closeDialog() {
      this.type = '';
      this.dialogVisible = false;
      this.formData = this.initData();
      this.$forceUpdate();
    }
  }
};